
import { RevLink } from '@backmarket/design-system'

import translations from '../../pages/product.translations'

export default {
  components: {
    RevLink,
  },
  computed: {
    translations: () => translations,
  },
}
